import React, { Component } from "react";
import "./styles.css";
import Icon from "../icon/view";

class CircleIcon extends Component {

  // ===============================================================================================
  render() {
    return (
      <div className={"circle-icon" +
        ((this.props.type) ? " circle-icon--" + this.props.type : "") +
        ((this.props.checked === true)  ? " circle-icon--checked" : "") +
        ((this.props.checked === false) ? " circle-icon--unchecked" : "") +
        ((this.props.disabled === true)  ? " circle-icon--disabled" : "") +
        ((this.props.className) ? " " + this.props.className : "")}>
        <Icon type={this.props.type}/>
      </div>
    );
  }

}



export default CircleIcon
